<template>
  <div class="ia-box-query">
    <ChatComponent
      v-if="!queryDone"
      :placeholder="texts.placeholder"
      :modelValue="suggestionText"
      :isLoading="isLoading"
      @new-query="handleQuerySubmit"
      @cancel-query="handleCancelQuery"
    />
    <ChatSuggestionsComponent v-if="!queryDone" @suggestion-selected="handleSuggestionSelected" />
    <ActualQueryComponent v-if="queryDone" :query="suggestionText" />
  </div>
</template>

<script setup lang="ts">
// IMPORTS
import { ref, computed } from 'vue'
import ChatComponent from '@/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ChatComponent.vue'
import ChatSuggestionsComponent from '@/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ChatSuggestionsComponent.vue'
import ActualQueryComponent from '@/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ActualQueryComponent.vue'
import { useI18n } from 'vue-i18n-composable'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'
import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'
import { FilterTypes } from '@/modules/documentSearcher/types/SearchIATypes'

const emit = defineEmits(['new-query'])

// TRANSLATIONS
const { t } = useI18n()
const texts = {
  suggestionsMore: t('components.search_advance_ia.more_suggestions'),
  placeholder: t('components.search_advance_ia.placeholder_query') as string
}

// STORE
const searchIAStore = useSearchIAStore()

// DATA
const suggestionText = ref('')

// COMPUTED
const queryDone = computed(() => searchIAStore.queryDone)
const isLoading = computed(() => searchIAStore.isLoading)

const handleSuggestionSelected = (suggestion: string) => {
  suggestionText.value = suggestion

  // Registrar evento de analítica
  trackEvent(TrackerEvents.CLICK_PROMPT_SUGGESTION, {
    prompt_name: suggestion
  })
}

const handleQuerySubmit = (data: any) => {
  if (data && data.query) {
    // Actualizar el texto de la sugerencia para que se mantenga en el campo de entrada
    suggestionText.value = data.query

    searchIAStore.fetchSearchIA({
      search: data.query,
      expedientName: data.filter?.type === FilterTypes.EXPEDIENT ? data.filter.value : undefined,
      contactName: data.filter?.type === FilterTypes.CONTACT ? data.filter.value : undefined
    })
    emit('new-query')
    queryDone.value = true
  }
}

const handleCancelQuery = () => {
  searchIAStore.cancelSearchIA()
}
</script>

<style lang="scss" scoped>
.ia-box-query {
  font-family: $inter-font;
  width: 100%;
}
</style>
